export const IMAGES = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/9292dbb36433cad87546dbeb6d4dd43921ea9b6483e3ebd76eca212fd163e350.jpeg",
  aboutTexture:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/719b6908d91fff4f2e010b0d0f4557f5363ce842eac4f90a17eb544297190c94.jpeg",
  programMind:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/804cd5135959630f918e915e6180fb62c7bff5345c7fcfd2d08b943e37573047.jpeg",
  programChild:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/6e5e2d7f9dc37b355b3ba286339767c2009021295de35e85e999a17e5ed6b5f0.jpeg",
  libraryBg:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/8f6f942757c77d2e6789a23f13120588f1b5a18bcd065da1495a0b127b9746a4.jpeg",
  founder:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/b6ab54fdb747652d13a6f015128a4a7c70e6c170fe7b97230059a89f82dbfa26.jpeg",
  heroSilhouette:
    "https://static.prod-images.emergentagent.com/jobs/f890c166-e0f0-4a09-8563-012452c7655b/images/9403b19332f8c06181c4822ad7b05db53a56f63fc9bc50bf56b2acb869e85ead.jpeg",
};
